import { Warning } from '@36node-fcp/core-sdk';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Image, Popover, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { styled } from 'styled-components';

import { IllegalLevelTag, toIllegalLevelColor } from 'src/features/illegal-type';

type WarningCardProps = {
  warning: Warning;
  selected?: boolean;
  onClick: () => void;
  onClose: () => void;
};

export const WarningCard: React.FC<WarningCardProps> = ({ warning, selected = false, onClick, onClose }) => {
  const { images = [], name, plate, level, capAt, gantry, nextGantry, predictionPercent } = warning;
  const image = images[0];

  return (
    <Box
      className={`animate__animated animate__lightSpeedInRight ${selected ? 'box-select' : ''}`}
      onClick={() => onClick()}
    >
      <Left style={{ borderColor: toIllegalLevelColor(level) }}>
        {image && <Image width="100%" height="100%" preview={false} src={image} />}
        {!image && <Image width="100%" height="100%" preview={false} src="src/assets/no-image.png" />}
        <div className="left-tag">
          <IllegalLevelTag level={level} />
        </div>
      </Left>
      <Right>
        <div className="card-header">
          <div className="title">{plate ? plate : '人员违法'}</div>
          {nextGantry && (
            <Popover content={<div style={{ color: 'white' }}>{`经过${nextGantry?.name}的概率`}</div>} color="black">
              <Tag color={toIllegalLevelColor(level)}>{`${predictionPercent}%`}</Tag>
            </Popover>
          )}
        </div>
        <div style={{ color: toIllegalLevelColor(level), fontWeight: 500 }}>{name}</div>
        <div style={{ width: '100%' }}>
          <Typography.Text style={{ marginRight: 8, color: 'rgba(0, 0, 0, 0.35)' }}>
            {dayjs(capAt).format('HH:mm:ss')}
          </Typography.Text>
          <Typography.Text style={{ wordBreak: 'break-all', color: 'rgba(0, 0, 0, 0.85)' }}>
            {gantry.name}
          </Typography.Text>
        </div>
      </Right>
      {selected && (
        <div className="icon-btn box-close" role="button" onClick={() => onClose()}>
          <CloseCircleOutlined style={{ fontSize: 20, zIndex: 1 }} />
        </div>
      )}
    </Box>
  );
};

const Box = styled.div`
  height: 122px;
  width: 448px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 16px;
  background: #f5f5f5;
  display: flex;
  position: relative;

  &.box-select {
    border: 2px solid rgba(0, 0, 0, 0.35);
    background: rgba(213, 30, 30, 0.15);
  }

  .icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    padding: 0;
    cursor: pointer;
    user-select: none;
    outline: none;
  }

  .box-close {
    position: absolute;
    top: -2px;
    right: -8px;
    z-index: 5;
    background: transparent;
  }

  .box-close::before {
    content: '';
    position: absolute;
    inset: 0; /* 等同 top:0;right:0;bottom:0;left:0 */
    border-radius: 50%;
    background: #fff; /* 白圆 */
    pointer-events: none; /* 不阻止点击/hover 等事件 */
    z-index: 0;
  }
`;

const Left = styled.div`
  width: 112px;
  height: 82px;
  border-radius: 4px;
  border: 4px solid;
  position: relative;
  overflow: hidden;

  .left-tag {
    position: absolute;
    top: 0px;
    right: -10px;
    z-index: 5;

    .ant-tag {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 4px;
    }
  }
`;

const Right = styled.div`
  flex: 1;
  margin-left: 16px;

  .card-header {
    width: 100%;
    padding-bottom: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 16px;
      font-weight: 600;
    }
  }
`;
